import { getClient } from '@carto/react-core/src/utils/clientParameter'
import { buildCustomOpts, deleteRequest } from 'features/common/api/requests'
import settings from 'settings'

const { apiBaseUrl } = settings
export const batchApiUrl = `${apiBaseUrl}/v3/sql`

export const deleteBatchJob = async ({
  connectionName,
  jobId,
  accessToken
}: {
  connectionName: string
  jobId: string
  accessToken?: string
}): Promise<{ status: string }> => {
  const url = `${batchApiUrl}/${connectionName}/job/${jobId}?client=${getClient()}`
  const jobStatus: { status: string } = await deleteRequest(url, buildCustomOpts({ accessToken }))
  return jobStatus
}
